import { FormsAPI } from '@weave/schema-gen-ts/dist/schemas/forms/forms_api.pb';
import { WFormsAPI } from '@weave/schema-gen-ts/dist/schemas/forms-digital/weave_digital_forms.pb';
import { QueryKey } from 'react-query';
import { bindHTTP } from '@frontend/schema';

export const SchemaDigitalForms = bindHTTP(WFormsAPI);
export const SchemaForms = bindHTTP(FormsAPI);
export const serviceKey: QueryKey = ['digital-forms'];
export const formServiceKey: QueryKey = ['forms'];
